<div class="row mt-4 justify-content-center">
  <div class="col-10">
    <ng-container *ngIf="location !== 'listing'">
      <div class="row">
        <div class="col-4">
          <p class="font-bold mb-2">Select Data</p>
          <app-tree-tab #treeTab (treeTabSelectedEvent)="onTreeTabSelected($event)" [showExport]="false"
            [currentTreeTab]="currentTreeTab" [treeTabItems]="treeTabItems" [exactTextNeeded]="true"
            [showTooltip]="false"></app-tree-tab>
        </div>

        <!-- list of configured table names starts -->
        <div class="col-4 col-xl-3" hidden>
          <label class="font-bold" for="tableViewSelector">Or Customise a Table View</label>
          <select class="custom-select" formcontrolname="fileType" id="tableViewSelector">
            <option>Table Views</option>
            <option>Default Table View</option>
          </select>
        </div>
        <!-- list of configured table names ends -->

      </div>
      <hr aria-hidden="true">
    </ng-container>

    <p *ngIf="location === 'listing'">Set Columns</p>
    <div class="row">
      <div class="dropdown col-4 taxonomy-selector">
        <app-auto-complete [listingObj]="additionalColumnList" (selectedObject)="addNewCol($event)"
          [selectType]="selectType" [uniqueId]="uniqueId" [propName]="dropdownData.propName"
          [defaultSelection]="columnList" [autoCompleteTitle]="autoCompleteTitle" [clearArray]="true"
          [showValidMsg]="false" [clrDisOnSelect]='false'
          [disabled]="columnList.length >= 10 || columnList === additionalColumnList" #autoComplete>
        </app-auto-complete>
      </div>
    </div>

    <div class="row">

      <!-- column-set for listing screen STARTS -->
      <div direction="horizontal" class="col-12 mb-4 mt-1 draggable-table" id="config_area"
        *ngIf="location === 'listing'">
        <as-split id="split_area" direction="horizontal" unit="pixel" gutterSize="5" (dragEnd)="columnResized($event)">
          <as-split-area *ngFor="let col of columnList;let i = index"
            class="d-flex col p-1 border drag justify-content-center align-items-start" id="col_{{i}}"
            [ngClass]="{'added': col.isAdded, 'hide': !col.isAdded}" size="{{col.width}}" minSize="100"
            [(dragDropList)]="columnList" (dragDropListChange)="changeList($event)"
            (mousedown)="$event.stopPropagation()">
            <div class="col-auto p-0 pr-1 position-absolute btn-icon move">
              <em class="material-icons-outlined font-4x" aria-hidden="true">drag_indicator</em>
            </div>
            <div class="col px-3">
              <p class="mb-0">
                {{col.name}}
              </p>
            </div>
            <div class="col-auto p-0 position-absolute remove" *ngIf="col.canRemove || col.customCol"
              (mousedown)="$event.stopPropagation()">
              <button type="button" class="btn btn-icon px-1 py-0" aria-label="Delete column"
                (click)="deleteCol($event,col)">
                <em class="material-icons-outlined font-1x" aria-hidden="true">close</em>
              </button>
            </div>

          </as-split-area>
        </as-split>
      </div>
      <!-- column-set for listing screen ENDS -->

      <!-- column-set for detail screen STARTS -->
      <div direction="horizontal" class="col-12 mb-4 mt-1 draggable-table" id="config_area"
        *ngIf="location === 'detail'">
        <as-split id="split_area" direction="horizontal" unit="pixel" gutterSize="5"
          [ngStyle]="{'overflow':showDropdown ? 'unset' : 'auto'}" (dragEnd)="columnResized($event)">
          <as-split-area *ngFor="let col of columnList;let i = index"
            class="d-flex col p-1 border drag justify-content-center align-items-start"
            [ngClass]="{'added': col.isAdded, 'hide': !col.isAdded}" id="col_{{i}}"
            size="{{(i === 0) ? '*' : col.width}}" minSize="100" [(dragDropList)]="columnList"
            (dragDropListChange)="changeList($event)" [ngStyle]="{'overflow':col.showDropdown ? 'unset' : 'auto'}"
            (mousedown)="$event.stopPropagation()">
            <div class="col-auto p-0 pr-1 position-absolute btn-icon move font-1x">
              <em class="material-icons-outlined font-4x" aria-hidden="true">drag_indicator</em>
            </div>

            <div class="col mx-2">
              <p class="mb-0 font-3x">
                {{col.display_name}}
              </p>

              <div class="col-12 p-0" *ngIf="currentTreeTab === 'Node Type'">
                <ul class="list-inline" *ngIf="col.metadataSelected">
                  <ng-container *ngFor="let metadata of col.metadata">
                    <li class="list-inline-item badge badge-secondary font-2x mb-2" *ngIf="metadata.selectDisplay">
                      {{ metadata.display_name ? metadata.display_name : metadata.name }}
                    </li>
                  </ng-container>
                </ul>

                <div class="col-12 p-0">
                  <app-multi-select-dropdown #metadataList [label]="'Add Metadata'" [data]="col.metadata"
                    id="{{'metadataList-'+i}}" [dropdownSettings]="dropdownSettings" [isNewLine]="true"
                    [isMandatory]="true" [selectedOptionList]="col.selectedMetadataList"
                    (SelectEvent)="updateSelection($event, col)" (dropdownEvent)="checkDropdownEvent()">
                  </app-multi-select-dropdown>
                </div>

              </div>
            </div>
            <div class="col-auto p-0 position-absolute remove" *ngIf="col.canRemove || col.customCol"
              (mousedown)="$event.stopPropagation()">
              <button type="button" class="btn btn-icon px-1 py-0" title="Delete column"
                aria-label="Delete column" (click)="deleteCol($event,col)" (mousedown)="$event.stopPropagation()">
                <em class="material-icons-outlined font-1x" aria-hidden="true">close</em>
              </button>
            </div>
          </as-split-area>
        </as-split>
      </div>
      <!-- column-set for detail screen ENDS -->
      <div class="col-12">
        <button type="button" class="btn btn-clear text-underline px-0" (click)="revertChanges()">Reset to Default Table
          View</button>
      </div>

    </div>
    <hr aria-hidden="true">
    <div class="row py-2">
      <div class="col-4">
        <p class="font-bold mb-0">Set as Custom Table configuration</p>
      </div>
      <div class="col-8">
        <div class="custom-control custom-switch">
          <input type="checkbox" class="custom-control-input" id="defaultConfiguration"
            aria-label="Toggle this to Set as default table configuration" [(ngModel)]="userDefault"
            (ngModelChange)="checkValidation()">
          <label class="custom-control-label" for="defaultConfiguration">{{userDefault ? 'ON' : 'OFF'}}</label>
        </div>
      </div>
    </div>
    <hr aria-hidden="true">
    <div class="row py-2">
      <div class="col-4">
        <p class="font-bold mb-0">Set as Default for all users
          {{location !== 'listing' ? ('accessing this ' + text) : ''}}</p>
      </div>
      <div class="col-8">
        <div class="custom-control custom-switch">
          <input type="checkbox" class="custom-control-input" id="defaultConfigurationAllUser"
            aria-label="Toggle this to Set as Default for all users accessing this project" [(ngModel)]="allUserDefault"
            [disabled]="!canSetDefaultForAll" (ngModelChange)="checkValidation()">
          <label class="custom-control-label"
            for="defaultConfigurationAllUser">{{allUserDefault ? 'ON' : 'OFF'}}</label>
        </div>
      </div>
    </div>
    <hr aria-hidden="true">
    <div class="row pt-2 pb-3" hidden>
      <div class="col-9">
        <label class="font-bold" for="configuredTableName">Configured Table Name</label>
        <input type="text" class="form-control" id="configuredTableName" placeholder="Enter Table Name">
      </div>
    </div>

  </div>
</div>
